import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const SetAllBotnetsSolved = (project_uid, accessToken) => {
  return axios.put(
    `${apiUrlInternal}/keyword_projects/${project_uid}/results/botnets/select-as-solved/all`,
    {},
    addAuthToFetchOpts(accessToken, {})
  ).then(res => res.data );
}


export const useSetAllBotnetsSolved = (fetcher = SetAllBotnetsSolved) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['set-as-solved-all-botnets'],
    (accessToken, project_uid) => fetcher(project_uid, accessToken),
    {onSuccess: (_, project_uid) => {
        queryClient.invalidateQueries(['set-as-solved-all-botnets']);
        queryClient.invalidateQueries(['keyword-project-results', project_uid]);
      }}
  )
}
